export const storeQuestion = async (resource, data) => {
    let question;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/question`, data)
      .then(
        (response) => {
          console.log(response);
          question = response.body.question;
        },
        (response) => {
          console.log(response);
        }
      );
    return question;
}
export const getQuestion = async (resource, data) => {
  let question;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/question/${data}`)
    .then(
      (response) => {
        console.log(response);
        question = response.body.question;
      },
      (response) => {
        console.log(response);
      }
    );
  return question;
}
export const deleteQuestion = async (resource, data) => {
  let question;
  await resource
    .delete(`api/${localStorage.getItem('perfil')}/question/${data}`)
    .then(
      (response) => {
        console.log(response);
        question = response.body.question;
      },
      (response) => {
        console.log(response);
      }
    );
  return question;
}
export const editQuestion = async (resource, id, data) => {
  let question;
  await resource
    .put(`api/${localStorage.getItem('perfil')}/question/${id}`,data)
    .then(
      (response) => {
        console.log(response);
        question = response.body.question;
      },
      (response) => {
        console.log(response);
      }
    );
  return question;
}